import { render } from "./AddDialog.vue?vue&type=template&id=4077d2da&scoped=true"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"

import "./AddDialog.vue?vue&type=style&index=0&id=4077d2da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4077d2da"

export default script